import { Badge } from "@/components/ui/base/badge";
import type { SupportTicketStatus } from "@/application/support/types";

const STATUS_VARIANT: Record<
  SupportTicketStatus,
  "success" | "warning" | "destructive"
> = {
  Synced: "success",
  Pending: "warning",
  Failed: "destructive",
};

export function SupportStatusBadge({
  status,
}: {
  status: SupportTicketStatus;
}) {
  return (
    // eslint-disable-next-line security/detect-object-injection -- controlled enum key
    <Badge variant={STATUS_VARIANT[status]}>{status}</Badge>
  );
}
